const inr = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2, minimumFractionDigits: 0 });

/** Rupees the way customers read them: ₹1,20,000 — paise only when there are any. */
export function money(value: number, currency = 'INR'): string {
  if (currency !== 'INR') {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency, maximumFractionDigits: 2 }).format(value);
  }
  return inr.format(value);
}

/** The unit price at a quantity, from the variant's price and its quantity breaks. */
export function priceAt(base: number | null, breaks: { minQty: number; price: number }[] | null, qty: number): number | null {
  if (base === null) return null;
  // Mirrors PriceResolution.Pick on the server: the break with the highest
  // minimum quantity the order reaches wins; below every break, the base price.
  let price = base;
  let best = 1;
  for (const b of breaks ?? []) {
    if (qty >= b.minQty && b.minQty >= best) {
      best = b.minQty;
      price = b.price;
    }
  }
  return price;
}
